import { isPlatformBrowser, JsonPipe, SlicePipe, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { LanguageService, FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';
import { SetTitle, SetTags } from 'src/app/store';
import {
  getAllNews,
  getAllNewsOrdered,
  getFeaturedNews,
  getFeaturedNewsOrdered,
  getNewsOverviewLoaded,
  getNewsOverviewLoading,
  getNewsPage,
  LoadMoreNews,
} from '../../store';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { Router, RouterLink } from '@angular/router';
import { NewsListCardComponent } from '../../components/news-list-card/news-list-card.component';
import { LoadingIndicatorComponent } from 'src/app/standalone/components/loading-indicator/loading-indicator.component';
import { IconComponent } from '@teamfoster/sdk/icon';
import { NewsCardComponent } from '../../components/news-card/news-card.component';

@Component({
    selector: 'app-news-overview',
    imports: [
        HeaderComponent,
        FromDictionaryPipe,
        NewsListCardComponent,
        RouterLink,
        LoadingIndicatorComponent,
        IconComponent,
        NewsCardComponent,
    ],
    templateUrl: './news-overview.component.html',
    styleUrl: './news-overview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsOverviewComponent {
  private store = inject(Store);
  private lang = inject(LanguageService);
  private dict = new FromDictionaryPipe(this.lang);

  news = this.store.selectSignal(getAllNewsOrdered);
  featured = this.store.selectSignal(getFeaturedNewsOrdered);
  loading = this.store.selectSignal(getNewsOverviewLoading);
  loaded = this.store.selectSignal(getNewsOverviewLoaded);

  newsPage = this.store.selectSignal(getNewsPage);

  newestFeaturedItem = computed(() => {
    const featured = this.featured();
    return featured.length > 0 ? featured[0] : null;
  });

  // remove newestfeaturedItem from news
  newsWithoutFeatured = computed(() => {
    const news = this.news();
    const featured = this.newestFeaturedItem();
    return featured ? news.filter(item => item.id !== featured.id) : news;
  });

  metafields = effect(
    () => {
      this.store.dispatch(
        SetTitle({ title: `${this.dict.transform('nieuws-overzicht-titel')} - ${this.dict.transform('meta-titel-suffix')}` })
      );
      this.store.dispatch(
        SetTags({
          properties: {
            'description': this.dict.transform('nieuws-overzicht-subtitel'),
            'og:title': `${this.dict.transform('nieuws-overzicht-titel')} - ${this.dict.transform('meta-titel-suffix')}`,
            'og:description': this.dict.transform('nieuws-overzicht-subtitel'),
          },
        })
      );
    },
    { allowSignalWrites: true }
  );
  loadMoreNews() {
    this.store.dispatch(LoadMoreNews());
  }
}
